import React, { Component, Fragment } from 'react';
import {connect} from 'react-redux';
import { CONFIG, CONFIG_API_BE, URL_AKM} from '../../../../../config';
import {cekCookies} from '../../../../../actions';
import __ from 'lodash';
import LoaderModal from '../../../../modal/LoaderModal';
import Loader from '../../../../Loader';
import Navbar from '../../../navbar/Navbar';
import Sidebar from '../../../sidebar/Sidebar';
import eduprimeApi from '../../../../../apis/eduprimeApi';
import akmApi from '../../../../../apis/akmApi';
import PaketProgramEntity from '../../../../../entity/PaketProgramEntity';


import { Row, Col, Modal } from 'react-bootstrap';
import { MuiPickersUtilsProvider,KeyboardDateTimePicker } from "@material-ui/pickers";
import Autocomplete from '@material-ui/lab/Autocomplete';
import DateFnsUtils from '@date-io/date-fns';
import {Button, FormControlLabel, Checkbox, TextField, Grid} from '@material-ui/core';

class ModalCreateUpdate extends Component {
    constructor(props) {
        super(props);

        this.state = {
            paketProgramEnty: props.paketProgramProps,
            listKelasGroup: props.listKelasGroup,
            isEidupay : false,
            isUssSbmptn: false
        }
    }

    componentDidUpdate(){
        console.log(this.state)
    }

    render() {
        const setFree = [
            { label: 'ALL', value: 'ALL' },
            { label: 'PSEP', value: 'PSEP' },
            { label: 'PREMIUM', value: 'PREMIUM' },
            { label: 'PAID ONLY', value: 'PAID' },
        ]; 

        const {paketProgramEnty, listKelasGroup, isEidupay, isUssSbmptn} = this.state;
        const {paketProgramProps} = this.props;

        return (
            <Row>
                <Col>
                    <Modal 
                        show={this.props.isOpen}
                        onHide={() => this.handleCloseModal()}
                        aria-labelledby="example-custom-modal-styling-title"
                        size="lg" backdrop="static" keyboard={false}>
                        <Modal.Header>
                            <Modal.Title>Paket Program {paketProgramProps.namaProgram}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {this.state.isSearch && <Loader /> } 
                            <form onSubmit={this.handleSubmit}>
                                <Grid
                                  container
                                  spacing={2}
                                  direction="column"
                                  justifyContent="flex-start"
                                  alignItems="stretch">
                                    <Grid item xs={12}>
                                        <TextField
                                            required
                                            id="namaProgram"
                                            label="Nama Paket Program"
                                            type="text"
                                            value={paketProgramProps.namaProgram ? paketProgramProps.namaProgram : paketProgramEnty.namaProgram}
                                            onChange={this.handleOnChangeInput}
                                        />
                                    </Grid>

                                    <Grid item xs={12} 
                                        container
                                        spacing={2}
                                        direction="row"
                                        justifyContent="space-between"
                                        alignItems="flex-start">
                                            <Grid item xs={6}>
                                                <MuiPickersUtilsProvider utils={DateFnsUtils} id="startedDate">
                                                    <KeyboardDateTimePicker   
                                                        value={paketProgramProps.startedDate ? paketProgramProps.startedDate : paketProgramEnty.startedDate} 
                                                        onChange={this.handleOnChangeStartDate}        
                                                        label="Paket Mulai"
                                                        onError={console.log}
                                                        ampm={false}
                                                        format="dd-MM-yyyy HH:mm" required
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                    <KeyboardDateTimePicker   
                                                        value={paketProgramProps.expiredDate ? paketProgramProps.expiredDate : paketProgramEnty.expiredDate}
                                                        onChange={this.handleOnChangeEndDate}        
                                                        label="Paket Selesai"
                                                        onError={console.log}
                                                        ampm={false}
                                                        format="dd-MM-yyyy HH:mm" required
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </Grid>
                                    </Grid>

                                    <Grid item xs={12} 
                                        container
                                        spacing={2}
                                        direction="row"
                                        justifyContent="space-between"
                                        alignItems="flex-start">
                                            <Grid item xs={4}>
                                                <Autocomplete                                                    
                                                    id="setFree"
                                                    options={setFree}
                                                    // value={paketProgramProps.setFree ? paketProgramProps.setFree : paketProgramEnty.setFree}
                                                    onChange={this.handleOnChangeInput}
                                                    disableClearable
                                                    getOptionLabel={(option) => option.label}
                                                    getOptionDisabled={(option) => 
                                                        option === setFree[0] || 
                                                        option === setFree[1] || 
                                                        option === setFree[2]
                                                    }
                                                    value={
                                                        paketProgramProps.setFree !== null
                                                            ? setFree.find(
                                                                (x) => x.value === paketProgramProps.setFree
                                                            )
                                                            : paketProgramEnty.setFree
                                                    }
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Pilih Set Free" required/>
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Autocomplete                                                    
                                                    id="idKelasGroup"
                                                    options={listKelasGroup}
                                                    onChange={this.handleOnChangeInput}
                                                    disableClearable
                                                    getOptionLabel={(option) => option.label}
                                                    value={
                                                        paketProgramProps.idKelasGroup !== null
                                                            ? listKelasGroup.find(
                                                                (x) => x.value === paketProgramProps.idKelasGroup
                                                            )
                                                            : paketProgramEnty.idKelasGroup
                                                    }
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Pilih Kelas Group" required/>
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <TextField
                                                    required
                                                    id="harga"
                                                    label="Harga " 
                                                    type="number"
                                                    value={paketProgramProps.harga ? paketProgramProps.harga : paketProgramEnty.harga}
                                                    onChange={this.handleOnChangeInput}
                                                />
                                            </Grid>
                                    </Grid>

                                    <Grid item xs={12} 
                                        container
                                        spacing={2}
                                        direction="row">
                                        <Grid item>
                                            {
                                                paketProgramProps.isEidupay ==  1 ?
                                                <>
                                                    {
                                                        !isEidupay ?
                                                        <FormControlLabel
                                                            control={<Checkbox checked={true} onChange={this.handleOnChangeInput} id="isEidupay" />}
                                                            label="A"
                                                        />
                                                        :
                                                        <FormControlLabel
                                                            control={<Checkbox checked={false} onChange={this.handleOnChangeInput} id="isEidupay" />}
                                                            label="B"
                                                        />

                                                    }
                                                </>
                                                :
                                                <>
                                                    <FormControlLabel
                                                        control={<Checkbox checked={isEidupay} onChange={this.handleOnChangeInput} id="isEidupay" />}
                                                        label="C"
                                                    />
                                                </>
                                            }
                                            
                                        </Grid>
                                        <Grid item>
                                            {isEidupay ? 'sT' : 'sF'}
                                            {paketProgramProps.isEidupay == 1 ? 'pT' : 'pF'}
                                            <FormControlLabel
                                                control={<Checkbox checked={paketProgramProps.ussSbmptn == 1 ? true : isUssSbmptn} onChange={this.handleOnChangeInput} id="isUssSbmptn" />}
                                                label="uss Sbmptn"
                                            />
                                            {JSON.stringify(this.props.paketProgramEntity)}
                                        </Grid>
                                    </Grid>
                                  
                                    <Grid item xs={12}>
                                        <Button variant="outlined" color="secondary" style={{float: 'left'}} onClick={() => this.handleCloseModal()}>
                                            <li className="fa fa-close"> Batal</li>
                                        </Button>
                                        <Button variant="outlined" color="primary" type="submit" style={{float: 'right'}}>
                                            <li className="fa fa-save"> Simpan</li>
                                        </Button>
                                    </Grid>
                                </Grid>
                            </form>
                        </Modal.Body>
                    </Modal>
                </Col>
            </Row>
        );
    }

    handleOnChangeInput = (e, value, reason) =>{
        const id = e.target.id;
        const val = e.target.value;

        console.groupCollapsed('ATAS');
        console.info('ID => ', id)
        console.info('val => ',val)
        console.info('REASON => ',reason)
        console.info('checked => ',e.target.checked)
        console.groupEnd();

        if(reason === 'select-option'){

            const idSplit = id.split('-');

            console.groupCollapsed('BAWAH');
            console.info('idSplit', idSplit);
            console.info('value', value);
            console.groupEnd();

            this.setState(prevState => ({     
                paketProgramEnty: {
                    ...prevState.paketProgramEnty,
                    [idSplit[0]]: value.value
                }            
            }))

        }else{
            if(id == 'isEidupay'){
                this.setState({isEidupay : !this.state.isEidupay});
                this.setState(prevState => ({     
                    paketProgramEnty: {
                        ...prevState.paketProgramEnty,
                        isEidupay: !this.state.isEidupay ? 1 : 0
                    }            
                }))

            }else if(id == 'isUssSbmptn'){
                this.setState({isUssSbmptn : !this.state.isUssSbmptn});
                this.setState(prevState => ({     
                    paketProgramEnty: {
                        ...prevState.paketProgramEnty,
                        ussSbmptn: !this.state.isUssSbmptn ? 1 : 0
                    }            
                }))

            }else {
                this.setState(prevState => ({     
                    paketProgramEnty: {
                        ...prevState.paketProgramEnty,
                        [id]: val
                    }            
                }))
            }
            

        }        
    }

    handleOnChangeStartDate  = (date) => {        
        this.setState(prevState => ({     
            paketProgramEnty: {
                ...prevState.paketProgramEnty,
                startedDate: date
            }            
        }))
    }

    handleOnChangeEndDate = (date) => {        
        this.setState(prevState => ({     
            paketProgramEnty: {
                ...prevState.paketProgramEnty,
                expiredDate: date
            }            
        }))
    }

    handleSubmit = async (e) =>{
        e.preventDefault();
        const {paketProgramEnty, isEidupay} = this.state;
        const response = await akmApi.post(URL_AKM.SIMPAN_PAKET_PROGRAM, paketProgramEnty
        ).catch(function(error){
            this.setState({error})
        })
        this.handleCloseModal()
    }

    handleCloseModal = async () => {
        this.setState({ 
            isOpen: false, 
            paketProgramEnty: {}
        })
        this.props.handleCloseModal();
    }

}
 
export default ModalCreateUpdate;